
import React, { Fragment, useEffect, useRef, useState } from 'react';
import Breadcrumb from '../../../components/common/breadcrumb';
import { Button, Card, CardBody, Container, Row, Table } from 'reactstrap';
import { FaBuilding } from "react-icons/fa";
import PosDropdownSection from '../../SalesManagement/Pos/PosDropdownSection';
import useGetData from '../../../hooks/useGetData';
import ReactDatePicker from "react-datepicker";
import TableLoading from '../../../components/common/loading/TableLoading';
import { useReactToPrint } from 'react-to-print';
import sanguImg from '../../../assets/images/dashboard/amr-shop.jpg'
const TrialBalance = () => {

  const [branchData, branchRefetch, isLoading] = useGetData(
    "/branch/viewbranch",
    "branch"
  );


  const [wareHouseDropdownValue, setWarehouseDropdownValue] = useState("");
  const [selectedItemData, setSelectedItemData] = useState([]);
  const [wareHouseDropdownId, setWarehouseDropdownId] = useState("");

  const [selectedWarehouse, setSelectedWarehouse] = useState()

  useEffect(()=>{
    if(branchData){
     const selectedItem =  branchData?.find((item)=>(
        item?.id === wareHouseDropdownId 

      ))
      setSelectedWarehouse(selectedItem);
    }
  },[branchData, wareHouseDropdownId])
 

  console.log(selectedWarehouse);

  const [startDate, setStartDate] = useState(new Date());
  const date = startDate;
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0 indexed
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();
  const purchaseDate = `${month}/${day}/${year}`;


  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });


  return (
    <Fragment>
      <Breadcrumb title='Trial Balance' parent='Accounts ' />
      <Container>
        <Card>
          <CardBody >
            <Row>
              <div
                className='col-md-6 d-flex justify-content-between align-items-center border border rounded-1 '
                title='Warehouse'>
                <span className=' px-2'>
                  <FaBuilding className='text-danger'></FaBuilding>
                </span>
                {/* dropdown data */}
                {branchData &&
                  <PosDropdownSection
                    borderEnd={'warehouse'}
                    inputType={'search'}
                    InitialDropdownValue={'All Branches'}
                    setWarehouseDropdownValue={setWarehouseDropdownValue}
                    data={branchData}
                    titleData={'Warehouse'}
                    placeHolderData={'Enter Branch Name'}
                    dataField={'warehouse_name'}
                    setSelectedItemData={setSelectedItemData}
                    setWarehouseDropdownId={
                      setWarehouseDropdownId
                    }></PosDropdownSection>
                }
              </div>

              <div className="col-md-6 gap-4">
                <div
                  style={{ width: "100%" }}
                  className=" d-flex align-items-center  rounded-1 "
                >
                  <span className="fw-bold px-2">
                    Filter by date:
                  </span>
                  <ReactDatePicker
                    showIcon
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                  />
                </div>
              </div>
            </Row>

            <div className='p-5' ref={componentRef}>

              <section
                className="d-flex justify-content-between border-bottom pb-3 border-black 
    "
              >
                {/* child-1 */}
                <div className="d-flex justify-content-between align-items-center col-6  gap-3">
                  <div className=" col-4">
                    <img src={sanguImg} alt="" className="img-fluid" />
                  </div>
                  <div className="col-8">
                    <h3 className="m-0 text-black fw-bold"> {wareHouseDropdownValue || "Please Select Your Branch"} </h3>
                    <p
                      className="m-0 text-black fw-bold"
                    >
                     {selectedWarehouse?.warehouse_address}
                    </p>
                    <p
                      className="m-0 text-black fw-bold
          "
                    >
                     {selectedWarehouse?.mobile}
                    </p>
                  </div>
                </div>
                {/* child-2 */}
                <div className="col-6 d-flex justify-content-end align-items-start">
                  <button className=" px-3 py-1 border-0 fw-3 fw-bolder">
                    Trial Balance
                  </button>
                </div>
              </section>

              <div className='mt-2 text-center fw-bold fw-5'> Branch Name: {wareHouseDropdownValue}  Date:{purchaseDate}</div>
              
                <div className='p-5'>
                  <Table
                    bordered
                    hover
                    striped
                    >
                    <thead className='text-center '>
                      <tr>
                        <th >Trial Balance </th>
                        <th > Debit </th>
                        <th > Credit </th>
                      </tr>
                    </thead>

                    <tbody className='text-center'>
                      {isLoading && (
                        <TableLoading
                          noRow={10}
                          noTd={3}
                        />
                      )}

                      {!isLoading && (
                        <>
                          <tr >
                            <th scope='row'> supplier</th>
                            <td>$2000</td>
                            <td>$3000</td>
                          </tr>
                          <tr >
                            <th scope='row'> Customer Deu:</th>
                            <td>$2000</td>
                            <td>$1000</td>
                          </tr>
                          <tr >
                            <th scope='row'> Account Balance:</th>
                            <td> </td>
                            <td> </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                    <tfoot className='text-center'>
                      <tr>
                        <th>Total </th>
                        <th>$50000.00</th>
                        <th>$40000.00</th>
                      </tr>
                    </tfoot>
                  </Table>
                </div>

            </div>

            <div className='d-flex flex-wrap align-items-center justify-content-center mt-1'>
              <Button onClick={handlePrint}>Print</Button>
            </div>

          </CardBody>
        </Card>
      </Container>
    </Fragment>
  );
};

export default TrialBalance;